import goingEvent from '../../global/goingEvent';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import dhtmlDragAndDropObject from '../dhtmlDragAndDropObject';
import dhtmlXTreeItemObject from './dhtmlXTreeItemObject';

var dhtmlXTreeObject = (function () {
    function dhtmlXTreeObject(o, _width, _height, a) {
        if (goingEvent.initTouch) {
            goingEvent.initTouch();
        }
        if (window._isIE) {
            try {
                document.execCommand("BackgroundImageCache", false, "true");
            }
            catch (n) {
                console.log(n,"--n-");
            }
        }
        if (typeof o != "object") {
            this.parentObject = document.getElementById(o);
        }
        else {
            this.parentObject = o;
        }
        //设置图标样式
        this.setIconMapping({});
        this.parentObject.style.overflow = "hidden";
        this._itim_dg = true;
        this.dlmtr = ",";
        this.dropLower = false;
        this.enableIEImageFix(true);
        this.xmlstate = 0;
        this.mytype = "tree";
        this.smcheck = true;
        this.width = _width;
        this.height = _height;
        this.rootId = a;
        this.childCalc = null;
        this.def_img_x = "18px";
        this.def_img_y = "18px";
        this.def_line_img_x = "18px";
        this.def_line_img_y = "24px";
        this._dragged = new Array();
        this._selected = new Array();
        this.style_pointer = "pointer";
        this._aimgs = true;
        this.htmlcA = " [";
        this.htmlcB = "]";
        this.lWin = window;
        this.cMenu = 0;
        this.mlitems = 0;
        this.iconURL = "";
        this.dadmode = 0;
        this.slowParse = false;
        this.autoScroll = true;
        this.hfMode = 0;
        this.nodeCut = new Array();
        this.XMLsource = 0;
        this.XMLloadingWarning = 0;
        this._idpull = {};
        this._pullSize = 0;
        this.treeLinesOn = true;
        this.tscheck = false;
        this.timgen = true;
        this.dpcpy = false;
        this._ld_id = null;
        this._dynDeleteBranches = {};
        this._oie_onXLE = [];
        this.imPath = window.dhx_globalImgPath || "";
        this.checkArray = new Array("iconUncheckAll.gif", "iconCheckAll.gif", "iconCheckGray.gif", "iconUncheckDis.gif", "iconCheckDis.gif", "iconCheckDis.gif");
        this.radioArray = new Array("radio_off.gif", "radio_on.gif", "radio_on.gif", "radio_off.gif", "radio_on.gif", "radio_on.gif");
        this.lineArray = new Array("line2.gif", "line3.gif", "line4.gif", "blank.gif", "blank.gif", "line1.gif");
        this.minusArray = new Array("minus2.gif", "minus3.gif", "minus4.gif", "minus.gif", "minus5.gif");
        this.plusArray = new Array("plus2.gif", "plus3.gif", "plus4.gif", "plus.gif", "plus5.gif");
        this.imageArray = new Array("leaf.gif", "folderOpen.gif", "folderClosed.gif");
        this.cutImg = new Array(0, 0, 0);
        this.cutImage = "but_cut.gif";
        dhx4._eventable(this);
        this.dragger = new dhtmlDragAndDropObject();
        this.htmlNode = new dhtmlXTreeItemObject(this.rootId, "", 0, this);
        this.htmlNode.htmlNode.childNodes[0].childNodes[0].style.display = "none";
        this.htmlNode.htmlNode.childNodes[0].childNodes[0].childNodes[0].className =
            "hiddenRow";
        this.allTree = this._createSelf();
        this.allTree.appendChild(this.htmlNode.htmlNode);
        if (dhtmlx.$customScroll) {
            dhtmlx.CustomScroll.enable(this);
        }
        if (window._isFF) {
            this.allTree.childNodes[0].width = "100%";
            this.allTree.childNodes[0].style.overflow = "hidden";
        }
        var h = this;
        this.allTree.onselectstart = new Function("return false;");
        if (window._isMacOS) {
            this.allTree.oncontextmenu = function (r) {

                return h._doContClick(r || window.event, true);
            };
        }
        this.allTree.onmousedown = function (r) {

            return h._doContClick(r || window.event);
        };
        this.XMLLoader = this._parseXMLTree;
        if (window._isIE) {
            this.preventIECashing(true);
        }
        this.selectionBar = document.createElement("DIV");
        this.selectionBar.className = "selectionBar";
        this.selectionBar.innerHTML = "&nbsp;";
        this.selectionBar.style.display = "none";
        this.allTree.appendChild(this.selectionBar);
        if (window.addEventListener) {
            window.addEventListener("unload", function () {
                try {
                    h.destructor();
                }
                catch (r) {
                    console.log(r,"--r-");
                }
            }, false);
        }
        if (window.attachEvent) {
            window.attachEvent("onunload", function () {
                try {
                    h.destructor();
                }
                catch (r) {
                    console.log(r,"--r-");
                }
            });
        }
        this.setImagesPath = this.setImagePath;
        this.setIconsPath = this.setIconPath;
        this.setSkin(dhx4.skin ||
            (typeof dhtmlx != "undefined" ? dhtmlx.skin : null) ||
            dhx4.skinDetect("dhxtree") ||
            "material");
        if (dhtmlx.image_path) {
            var m = dhtmlx.image_path;
            var g = this.parentObject.className.match(/dhxtree_dhx_([a-z_]*)/i);
            if (g != null && g[1] != null) {
                m += "dhxtree_" + g[1] + "/";
            }
            this.setImagePath(m);
        }
        return this;
    }
    return dhtmlXTreeObject;
})();
dhtmlXTreeObject.prototype.setDataMode = function (a) {
    this._datamode = a;
};
dhtmlXTreeObject.prototype._doContClick = function (m, a) {
    if (!a && m.button != 2) {
        if (this._acMenu) {
            if (this._acMenu.hideContextMenu) {
                this._acMenu.hideContextMenu();
            }
            else {
                this.cMenu._contextEnd();
            }
        }
        return true;
    }
    var c = window._isIE ? m.srcElement : m.target;
    while (c && c.tagName != "BODY") {
        if (c.parentObject) {
            break;
        }
        c = c.parentNode;
    }
    if (!c || !c.parentObject) {
        return true;
    }
    var h = c.parentObject;
    if (!this.callEvent("onRightClick", [h.id, m])) {
        (m.srcElement || m.target).oncontextmenu = function (r) {
            (r || event).cancelBubble = true;
            return false;
        };
    }
    this._acMenu = h.cMenu || this.cMenu;
    if (this._acMenu) {
        if (!this.callEvent("onBeforeContextMenu", [h.id])) {
            return true;
        }
        if (!window._isMacOS) {
            (m.srcElement || m.target).oncontextmenu = function (r) {
                (r || event).cancelBubble = true;
                return false;
            };
        }
        if (this._acMenu.showContextMenu) {
            var g = window.document.documentElement;
            var e = window.document.body;
            var n = new Array(g.scrollLeft || e.scrollLeft, g.scrollTop || e.scrollTop);
            var o = null, l = null;
            if (window._isIE) {
                o = m.clientX + n[0];
                l = m.clientY + n[1];
            }
            else {
                o = m.pageX;
                l = m.pageY;
            }
            this._acMenu.showContextMenu(o - 1, l - 1);
            this.contextID = h.id;
            m.cancelBubble = true;
            this._acMenu._skip_hide = true;
        }
        else {
            c.contextMenuId = h.id;
            c.contextMenu = this._acMenu;
            c.a = this._acMenu._contextStart;
            c.a(c, m);
            c.a = null;
        }
        return false;
    }
    return true;
};
//设置图标样式
dhtmlXTreeObject.prototype.setIconMapping=function (options) {
    //默认图片映射
    let urlNameMap={
        radio_off:`ivu-icon ivu-icon-md-radio-button-off`,
        radio_on:`ivu-icon ivu-icon-md-radio-button-on submit-color`,
        folderOpen:`ivu-icon ivu-icon-ios-folder-open`,
        folderClosed:'ivu-icon ivu-icon-ios-folder',
        leaf:`ivu-icon ivu-icon-md-folder`,
        iconUncheckAll:`ivu-icon ivu-icon-md-square-outline`,
        iconCheckAll:'ivu-icon ivu-icon-md-checkbox',
        plus:'ivu-icon ivu-icon-ios-arrow-forward',
        minus:'ivu-icon ivu-icon-ios-arrow-down',
        blank:'going-blank',
        iconCheckGray:'ivu-icon ivu-icon-md-checkbox-outline',
    };
    this.urlNameMap=$.extend(urlNameMap,options);
}
dhtmlXTreeObject.prototype.enableIEImageFix = function (a) {

    if (!a) {
        this._getImg = function (c) {
            return document.createElement(c == this.rootId ? "div" : "img");
        };
        this._setSrc = function (e, c) {
            e.src = c;
        };
        this._getSrc = function (c) {
            return c.src;
        };
    }
    else {
        this._getImg = function () {
            var c = document.createElement("DIV");
            c.innerHTML = "&nbsp;";
            c.className = "dhx_bg_img_fix";
            return c;
        };
        this._setSrc = function (e, c) {
            let  urlName=c.split("/")[c.split("/").length-1].split(".")[0];
            $(e).attr("class",` tree_icon ${urlName} dhx_bg_img_fix ${this.urlNameMap[urlName]} `);
            // e.style.backgroundImage = "url(" + c + ")";
        };
        this._getSrc = function (c) {
            var e = c.style.backgroundImage;
            return e.substr(4, e.length - 5).replace(/(^")|("$)/g, "");
        };
    }
};
dhtmlXTreeObject.prototype.destructor = function () {
    for (var c in this._idpull) {
        var e = this._idpull[c];
        if (!e) {
            continue;
        }
        e.parentObject = null;
        e.treeNod = null;
        e.childNodes = null;
        e.span = null;
        if(e.tr){
            e.tr.nodem = null;
        }
        e.tr = null;
        e.htmlNode.objBelong = null;
        e.htmlNode = null;
        this._idpull[c] = null;
    }
    this.parentObject.innerHTML = "";
    this.allTree.onselectstart = null;
    this.allTree.oncontextmenu = null;
    this.allTree.onmousedown = null;
    for (var cObj in this) {
        this[cObj] = null;
    }
};
dhtmlXTreeObject.prototype._globalIdStorageAdd = function (c, a) {
    if (this._globalIdStorageFind(c, 1, 1)) {
        c = c + "_" + new Date().valueOf();
        return this._globalIdStorageAdd(c, a);
    }
    this._idpull[c] = a;
    this._pullSize++;
    return c;
};
dhtmlXTreeObject.prototype._globalIdStorageSub = function (a) {
    if (this._idpull[a]) {
        this._unselectItem(this._idpull[a]);
        this._idpull[a] = null;
        this._pullSize--;
    }
    if (this._locker && this._locker[a]) {
        this._locker[a] = false;
    }
};
dhtmlXTreeObject.prototype._globalIdStorageFind = function (l, a, e, g) {
    var h = this._idpull[l];
    if (h) {
        if (h.unParsed && !e) {
            this.reParse(h, 0);
        }
        if (this._srnd && !h.htmlNode) {
            this._buildSRND(h, e);
        }
        if (g && this._edsbpsA) {
            for (var c = 0; c < this._edsbpsA.length; c++) {
                if (this._edsbpsA[c][2] == l) {
                    dhx4.callEvent("ongetItemError", [
                        "Requested item still in parsing process.",
                        l
                    ]);
                    return null;
                }
            }
        }
        return h;
    }
    if (this.slowParse && l != 0 && !a) {
        return this.preParse(l);
    }
    else {
        return null;
    }
};
dhtmlXTreeObject.prototype._getSubItemsXML = function (a) {
    var c = [];
    a.each("item", function (e) {
        c.push(e.get("id"));
    }, this);
    return c.join(this.dlmtr);
};
dhtmlXTreeObject.prototype.enableSmartXMLParsing = function (a) {
    this.slowParse = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.findXML = function () { };
dhtmlXTreeObject.prototype._getAllCheckedXML = function (c, a, g) {
    var e = [];
    if (g == 2) {
        c.through("item", "checked", -1, function (h) {
            e.push(h.get("id"));
        }, this);
    }
    if (g == 1) {
        c.through("item", "id", null, function (h) {
            if (h.get("checked") && h.get("checked") != -1) {
                e.push(h.get("id"));
            }
        }, this);
    }
    if (g == 0) {
        c.through("item", "id", null, function (h) {
            if (!h.get("checked") || h.get("checked") == 0) {
                e.push(h.get("id"));
            }
        }, this);
    }
    if (e.length) {
        return a + (a ? this.dlmtr : "") + e.join(this.dlmtr);
    }
    if (a) {
        return a;
    }
    else {
        return "";
    }
};
dhtmlXTreeObject.prototype._setSubCheckedXML = function (a, c) {
    var e = a ? "1" : "";
    c.through("item", "id", null, function (g) {
        if (!g.get("disabled") || g.get("disabled") == 0) {
            g.set("checked", e);
        }
    }, this);
};
dhtmlXTreeObject.prototype._getAllScraggyItemsXML = function (e) {
    var g = [];
    var c = function (h) {
        if (!h.sub_exists("item")) {
            g.push(h.get("id"));
        }
        else {

            h.each("item", c, this);
        }
    };
    c(e);
    return g.join(",");
};
dhtmlXTreeObject.prototype._getAllFatItemsXML = function (e) {
    var g = [];
    var c = function (h) {
        if (!h.sub_exists("item")) {
            return;
        }
        g.push(h.get("id"));

        h.each("item", c, this);
    };
    c(e);
    return g.join(",");
};
dhtmlXTreeObject.prototype._getAllSubItemsXML = function (e, cE, a) {
    var c = [];
    a.through("item", "id", null, function (g) {
        c.push(g.get("id"));
    }, this);
    return c.join(",");
};
dhtmlXTreeObject.prototype.reParse = function (e) {
    var l = this;
    if (!this.parsCount) {
        l.callEvent("onXLS", [l, e.id]);
    }
    this.xmlstate = 1;
    var g = e.unParsed;
    e.unParsed = 0;
    this.XMLloadingWarning = 1;
    var a = this.parsingOn;
    var m = this.waitUpdateXML;
    var o = this.parsedArray;
    this.parsedArray = new Array();
    this.waitUpdateXML = false;
    this.parsingOn = e.id;
    this.parsedArray = new Array();
    this.setCheckList = "";
    this._parse(g, e.id, 2);
    var r = this.setCheckList.split(this.dlmtr);
    for (var h = 0; h < this.parsedArray.length; h++) {
        e.htmlNode.childNodes[0].appendChild(this.parsedArray[h]);
    }
    if (g.get("order") && g.get("order") != "none") {
        this._reorderBranch(e, g.get("order"), true);
    }
    this.oldsmcheck = this.smcheck;
    this.smcheck = false;
    for (var c = 0; c < r.length; c++) {
        if (r[c]) {
            this.setCheck(r[c], 1);
        }
    }
    this.smcheck = this.oldsmcheck;
    this.parsingOn = a;
    this.waitUpdateXML = m;
    this.parsedArray = o;
    this.XMLloadingWarning = 0;
    this._redrawFrom(this, e);
    if (this._srnd && !e._sready) {
        this.prepareSR(e.id);
    }
    this.xmlstate = 0;
    return true;
};
dhtmlXTreeObject.prototype.preParse = function (c) {
    if (!c || !this._p) {
        return null;
    }
    var a = false;
    this._p.clone().through("item", "id", c, function (g) {

        this._globalIdStorageFind(g.up().get("id"));
        return (a = true);
    }, this);
    if (a) {
        var e = this._globalIdStorageFind(c, true, false);
        if (!e) {
            dhx4.callEvent("ongetItemError", [
                "The item " +
                    c +
                    " not operable. Seems you have non-unique|incorrect IDs in tree's XML.",
                c
            ]);
        }
    }
    return e;
};
dhtmlXTreeObject.prototype._escape = function (a) {
    switch (this.utfesc) {
        case "none":
            return a;
        case "utf8":
            return encodeURIComponent(a);
        default:
            return escape(a);
    }
};
dhtmlXTreeObject.prototype._drawNewTr = function (h) {
    var g = document.createElement("tr");
    var c = document.createElement("td");
    var a = document.createElement("td");
    c.appendChild(document.createTextNode(" "));
    a.colSpan = 3;
    a.appendChild(h);
    g.appendChild(c);
    g.appendChild(a);
    return g;
};
dhtmlXTreeObject.prototype.parse = function (g, e, a) {
    if (typeof e == "string") {
        a = e;
        e = null;
    }
    if (a === "json") {
        return this._loadJSONObject(g, e);
    }
    else {
        if (a === "csv") {
            return this._loadCSVString(g, e);
        }
        else {
            if (a === "jsarray") {
                return this._loadJSArray(g, e);
            }
        }
    }
    var c = this;
    if (!this.parsCount) {
        this.callEvent("onXLS", [c, null]);
    }
    this.xmlstate = 1;
    this.XMLLoader({ responseXML: dhx4.ajax.parse(g) }, e);
};
dhtmlXTreeObject.prototype.loadXMLString = function () {
    if (window.console && window.console.info) {
        window.console.info("loadXMLString was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this.parse.apply(this, arguments);
};
dhtmlXTreeObject.prototype.load = function (c, h, e) {
    if (typeof h == "string") {
        e = h;
        h = null;
    }
    e = e || this._datamode;
    if (e === "json") {
        return this._loadJSON(c, h);
    }
    else {
        if (e === "csv") {
            return this._loadCSV(c, h);
        }
        else {
            if (e === "jsarray") {
                return this._loadJSArrayFile(c, h);
            }
        }
    }
    var g = this;
    if (!this.parsCount) {
        this.callEvent("onXLS", [g, this._ld_id]);
    }
    this._ld_id = null;
    this.xmlstate = 1;
    this.XMLLoader = this._parseXMLTree;
    var a = this;
    dhx4.ajax.get(c, function (l) {
        a.XMLLoader(l.xmlDoc, h);
        a = null;
    });
};
dhtmlXTreeObject.prototype.loadXML = function () {
    if (window.console && window.console.info) {
        window.console.info("loadXML was deprecated", "http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44");
    }
    return this.load.apply(this, arguments);
};
dhtmlXTreeObject.prototype._attachChildNode = function (m, l, g, o, E, D, C, r, e, v, w) {
    if (v && v.parentObject) {
        m = v.parentObject;
    }
    if (m.XMLload == 0 && this.XMLsource && !this.XMLloadingWarning) {
        m.XMLload = 1;
        this._loadDynXML(m.id);
    }
    var s = m.childsCount;
    var F = m.childNodes;
    if (w && w.tr.previousSibling) {
        if (w.tr.previousSibling.previousSibling) {
            v = w.tr.previousSibling.nodem;
        }
        else {
            r = r.replace("TOP", "") + ",TOP";
        }
    }
    if (v) {
        var h, A;
        for (h = 0; h < s; h++) {
            if (F[h] == v) {
                for (A = s; A != h; A--) {
                    F[1 + A] = F[A];
                }
                break;
            }
        }
        h++;
        s = h;
    }
    var x = null;
    if (r) {
        x = r.split(",");
        for (var y = 0; y < x.length; y++) {
            switch (x[y]) {
                case "TOP":
                    if (m.childsCount > 0) {
                        v = new Object();
                        v.tr = m.childNodes[0].tr.previousSibling;
                    }
                    m._has_top = true;
                    for (h = s; h > 0; h--) {
                        F[h] = F[h - 1];
                    }
                    s = 0;
                    break;
            }
        }
    }
    var u;
    if (!(u = this._idpull[l]) || u.span != -1) {
        u = F[s] = new dhtmlXTreeItemObject(l, g, m, this, o, 1);
        l = F[s].id;
        m.childsCount++;
    }
    if (!u.htmlNode) {
        u.label = g;
        u.htmlNode = this._createItem(this.checkBoxOff ? 1 : 0, u);
        u.htmlNode.objBelong = u;
    }
    if (E) {
        u.images[0] = E;
    }
    if (D) {
        u.images[1] = D;
    }
    if (C) {
        u.images[2] = C;
    }
    var c = this._drawNewTr(u.htmlNode);
    if (this.XMLloadingWarning || this._hAdI) {
        u.htmlNode.parentNode.parentNode.style.display = "none";
    }
    if (v && v.tr && v.tr.nextSibling) {
        m.htmlNode.childNodes[0].insertBefore(c, v.tr.nextSibling);
    }
    else {
        if (this.parsingOn == m.id) {
            this.parsedArray[this.parsedArray.length] = c;
        }
        else {
            m.htmlNode.childNodes[0].appendChild(c);
        }
    }
    if (v && !v.span) {
        v = null;
    }
    if (this.XMLsource) {
        if (e && e != 0) {
            u.XMLload = 0;
        }
        else {
            u.XMLload = 1;
        }
    }
    u.tr = c;
    c.nodem = u;
    if (m.itemId == 0) {
        c.childNodes[0].className = "hiddenRow";
    }
    if (m._r_logic || this._frbtr) {
        this._setSrc(u.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0], this.imPath + this.radioArray[0]);
    }
    if (r) {
        x = r.split(",");
        for (var y_1 = 0; y_1 < x.length; y_1++) {
            switch (x[y_1]) {
                case "SELECT":
                    this.selectItem(l, false);
                    break;
                case "CALL":
                    this.selectItem(l, true);
                    break;
                case "CHILD":
                    u.XMLload = 0;
                    break;
                case "CHECKED":
                    if (this.XMLloadingWarning) {
                        this.setCheckList += this.dlmtr + l;
                    }
                    else {
                        this.setCheck(l, 1);
                    }
                    break;
                case "HCHECKED":
                    this._setCheck(u, "unsure");
                    break;
                case "OPEN":
                    u.openMe = 1;
                    break;
            }
        }
    }
    if (!this.XMLloadingWarning) {
        if (this._getOpenState(m) < 0 && !this._hAdI) {
            this.openItem(m.id);
        }
        if (v) {
            this._correctPlus(v);
            this._correctLine(v);
        }
        this._correctPlus(m);
        this._correctLine(m);
        this._correctPlus(u);
        if (m.childsCount >= 2) {
            this._correctPlus(F[m.childsCount - 2]);
            this._correctLine(F[m.childsCount - 2]);
        }
        if (m.childsCount != 2) {
            this._correctPlus(F[0]);
        }
        if (this.tscheck) {
            this._correctCheckStates(m);
        }
        if (this._onradh) {
            if (this.xmlstate == 1) {
                var a = this.onXLE;
                this.onXLE = function (n) {
                    this._onradh(l);
                    if (a) {
                        a(n);
                    }
                };
            }
            else {
                this._onradh(l);
            }
        }
    }
    return u;
};
dhtmlXTreeObject.prototype.enableContextMenu = function (a) {
    if (a) {
        this.cMenu = a;
    }
};

export default dhtmlXTreeObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dhtmlXTreeObject.js